/* unplugin-vue-components disabled */import __unplugin_components_1 from 'D:/workspace/space-time-web/src/components/Pagination/index.vue';
import __unplugin_components_0 from 'D:/workspace/space-time-web/src/components/RightToolbar/index.vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "ele-wrapper-bgCard"
};
const _hoisted_3 = {
  class: "app-container"
};
const _hoisted_4 = {
  class: "head-container"
};
const _hoisted_5 = {
  class: "head-container"
};
const _hoisted_6 = {
  key: 0,
  class: "list"
};
const _hoisted_7 = {
  class: "zngaojing"
};
const _hoisted_8 = {
  class: "zngaojingright"
};
const _hoisted_9 = {
  class: "zitiyangshi"
};
const _hoisted_10 = ["title"];
const _hoisted_11 = ["title"];
const _hoisted_12 = {
  key: 1,
  class: "no-data"
};
const _hoisted_13 = {
  class: "col-4-div"
};
const _hoisted_14 = {
  style: {
    "background": "rgb(2,21,40)",
    "width": "100%",
    "border": "#1d5390 solid"
  }
};
const _hoisted_15 = {
  colspan: "2"
};
const _hoisted_16 = {
  key: 0
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = {
  key: 1,
  colspan: "2"
};
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  key: 1
};
const _hoisted_26 = ["rowspan"];
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  key: 1
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  key: 1
};
import { getAlarmList, getPointList } from "@/api/alarm/alarmInfo";
import { getTaskDeviceListNoChild, treeSelectTaskInDept } from "@/api/base/taskmanager";
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const loading = ref(true);
    const dateRange = ref([]);
    const devicesOptions = ref([]);
    const scrollBarImg = ref(null);
    const showSearch = ref(true);
    const total = ref(0);
    const picToText = ref(false);
    const deptOptions = ref(undefined);
    const pageSizes = ref([8]);
    const alarmData = reactive({
      alarmList: []
    });
    const data = reactive({
      indexScroll: 0,
      detailInfo: {
        index: 0,
        show: false,
        alarmDetail: {}
      },
      queryTree: {
        taskName: '',
        taskDate: [],
        deviceId: undefined
      },
      queryParams: {
        pageNum: 1,
        pageSize: 8,
        selectLabel: 1,
        startDate: '',
        endDate: '',
        reportLevelList: [],
        pointIdList: [],
        reportNoList: [],
        deptId: undefined,
        taskId: undefined,
        deviceId: undefined
      },
      statusOptions: [{
        value: 2,
        label: '所有'
      }, {
        value: 1,
        label: '未处理'
      }, {
        value: 0,
        label: '已处理'
      }],
      pointList: [],
      pointIdOptions: []
    });
    const getAllPointList = () => {
      getPointList().then(response => {
        data.pointList = response.data;
      });
    };
    const getAlarmInfoListByPointIdList = () => {
      console.log(data.pointIdOptions);
      let options = [];
      data.queryParams.pointIdList = [];
      if (data.pointIdOptions.length > 0) {
        for (let pointIdListElement of data.pointIdOptions) {
          console.log(pointIdListElement[pointIdListElement.length - 1]);
          options.push(pointIdListElement[pointIdListElement.length - 1]);
        }
      }
      data.queryParams.reportNoList = options;
      console.log(data.queryParams);
    };
    const refreshTree = () => {
      data.queryTree.deviceId = data.queryParams.deviceId;
      data.queryTree.taskStarttime = data.queryTree.taskDate[0];
      data.queryTree.taskEndtime = data.queryTree.taskDate[1];
      treeSelectTaskInDept(data.queryTree).then(response => {
        deptOptions.value = response.data;
      });
    };
    /** 查询部门下拉树结构 */
    const getTreeselect = () => {
      treeSelectTaskInDept(data.queryTree).then(response => {
        deptOptions.value = response.data;
      });
    };
    const taskDeviceListNoChild = () => {
      getTaskDeviceListNoChild().then(response => {
        devicesOptions.value = response.data;
        console.log(devicesOptions.value);
      });
    };

    /** 查询告警列表 */
    const getList = () => {
      loading.value = true;
      data.queryParams.startDate = '';
      data.queryParams.endDate = '';
      console.log(dateRange.value);
      if (dateRange.value !== null && dateRange.value.length > 0) {
        data.queryParams.startDate = dateRange.value[0];
        data.queryParams.endDate = dateRange.value[1];
      }
      getAlarmList(data.queryParams).then(res => {
        console.log(res);
        loading.value = false;
        alarmData.alarmList = res.rows;
        total.value = res.total;
        data.detailInfo.alarmDetail = alarmData.alarmList[data.detailInfo.index];
      });
    };
    const updatePicToText = () => {
      picToText.value = !picToText.value;
    };
    const renderContent = (h, {
      node,
      data,
      store
    }) => {
      if (data.id > 0) {
        return h('span', {
          class: 'custom-tree-node'
        }, h('span', {
          style: 'color: #FFFFF'
        }, node.label));
      } else {
        return h('span', {
          class: 'custom-tree-node'
        }, h('span', {
          style: 'color: #409EFF'
        }, node.label));
      }
    };

    /** 节点单击事件 */
    function handleNodeClick(a) {
      console.log("我被点击了");
      console.log(a);
      data.queryParams.deptId = undefined;
      data.queryParams.taskId = undefined;
      if (a.id) data.queryParams.deptId = a.id;
      if (a.taskId) {
        data.queryParams.taskId = a.taskId;
      }
      handleQuery();
    }

    /** 搜索按钮操作 */
    function handleQuery() {
      data.queryParams.pageNum = 1;
      getList();
    }

    /** 重置按钮操作 */
    function resetQuery() {
      dateRange.value = [];
      data.pointIdOptions = [];
      proxy.resetForm("queryRef");
      data.queryParams = {
        pageNum: 1,
        pageSize: 8,
        selectLabel: 1,
        startDate: '',
        endDate: '',
        reportLevelList: [],
        pointIdList: [],
        reportNoList: [],
        deptId: undefined,
        taskId: undefined
      };
      handleQuery();
    }
    const handleView = index => {
      console.log(index);
      data.detailInfo.show = true;
      data.detailInfo.alarmDetail = alarmData.alarmList[index];
      data.detailInfo.index = index;
    };
    const closeDialog = () => {
      data.detailInfo.show = false;
      data.detailInfo.alarmDetail = {};
    };
    const handleScroll = e => {
      let direction = e.deltaY > 0 ? 'down' : 'up'; //deltaY为正则滚轮向下，为负滚轮向上
      let scrollBarStatus = 'top';
      console.log(scrollBarImg.value.scrollTop);
      console.log(scrollBarImg.value.clientHeight);
      console.log(scrollBarImg.value.scrollHeight);
      console.log(data.indexScroll);
      if (scrollBarImg.value.scrollTop === 0) {
        scrollBarStatus = 'top';
      } else if (scrollBarImg.value.scrollTop + scrollBarImg.value.clientHeight >= scrollBarImg.value.scrollHeight - 10) {
        scrollBarStatus = 'bottom';
      } else {
        scrollBarStatus = 'middle';
      }
      if (scrollBarImg.value.clientHeight === scrollBarImg.value.scrollHeight) {
        if (direction === 'down') {
          //125为用户一次滚动鼠标的wheelDelta的值
          nextOne(2);
        }
        if (direction === 'up') {
          nextOne(3);
        }
      }
      if (direction === 'down') {
        //125为用户一次滚动鼠标的wheelDelta的值
        if (scrollBarStatus === 'bottom') {
          if (data.indexScroll > 0) {
            nextOne(2);
            data.indexScroll = 0;
            scrollBarImg.value.scrollTop = 0;
          } else {
            data.indexScroll++;
          }
        }
      }
      if (direction === 'up') {
        if (scrollBarStatus === 'top') {
          if (data.indexScroll > 0) {
            nextOne(3);
            data.indexScroll = 0;
            scrollBarImg.value.scrollTop = 0;
          } else {
            data.indexScroll++;
          }
        }
      }
    };
    let isMethodCalled = false;
    const nextOne = i => {
      //直接下移一个位置 3直接上移一个位置
      if (i === 2) {
        if (data.detailInfo.index === alarmData.alarmList.length - 1) {
          if (data.queryParams.pageNum * data.queryParams.pageSize >= total.value) {
            if (!isMethodCalled) {
              proxy.$modal.notify("已经是最后一条数据了");
              isMethodCalled = true;
              setTimeout(() => {
                isMethodCalled = false;
              }, 5000);
            }
            return;
          } else {
            data.queryParams.pageNum++;
            data.detailInfo.index = 0;
            getList();
            //proxy.$modal.notify("加载下一页")
            return;
          }
        }
        data.detailInfo.index++;
      } else if (i === 3) {
        if (data.detailInfo.index === 0) {
          if (data.queryParams.pageNum === 1) {
            if (!isMethodCalled) {
              proxy.$modal.notify("已经是第一条数据了");
              isMethodCalled = true;
              setTimeout(() => {
                isMethodCalled = false;
              }, 5000);
            }
            return;
          } else {
            data.queryParams.pageNum--;
            data.detailInfo.index = 7;
            getList();
            //proxy.$modal.notify("加载上一页")
            return;
          }
        }
        data.detailInfo.index--;
      }
      data.detailInfo.alarmDetail = alarmData.alarmList[data.detailInfo.index];
    };
    onMounted(() => {
      data.queryParams.taskId = history.state.taskId;
      taskDeviceListNoChild();
      getTreeselect();
      getList();
      getAllPointList();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_right_toolbar = __unplugin_components_0;
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_1;
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
        gutter: 48
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4,
          xs: 24
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form_item, {
            label: "任务名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(data).queryTree.taskName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(data).queryTree.taskName = $event),
              clearable: "",
              placeholder: "任务名称",
              "prefix-icon": "Search",
              onInput: refreshTree
            }, null, 8, ["modelValue"])]),
            _: 1
          })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tree, {
            ref: "deptTreeRef",
            data: _unref(deptOptions),
            "expand-on-click-node": false,
            props: {
              label: 'label',
              children: 'children'
            },
            "default-expand-all": "",
            "highlight-current": "",
            "render-content": renderContent,
            onNodeClick: handleNodeClick
          }, null, 8, ["data"])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 20,
          xs: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_el_form, {
              ref: "queryRef",
              inline: true,
              model: _unref(data).queryParams,
              "label-width": "6rem"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "设备",
                prop: "status"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(data).queryParams.deviceId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(data).queryParams.deviceId = $event),
                  clearable: "",
                  placeholder: "设备名称",
                  style: {
                    "width": "15rem"
                  },
                  onChange: refreshTree
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(devicesOptions), dict => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: dict.id,
                      label: dict.name,
                      value: dict.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "时间",
                prop: "name"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: _unref(dateRange),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dateRange) ? dateRange.value = $event : null),
                  type: "daterange",
                  "range-separator": "TO",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  size: 'default',
                  style: {
                    "width": "20rem"
                  },
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                class: "title",
                label: "类别",
                prop: "pointIdList"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_cascader, {
                  modelValue: _unref(data).pointIdOptions,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(data).pointIdOptions = $event),
                  size: 'default',
                  style: {
                    "width": "23rem"
                  },
                  "show-all-levels": false,
                  clearable: "",
                  "collapse-tags": true,
                  options: _unref(data).pointList,
                  props: {
                    multiple: true
                  },
                  onChange: getAlarmInfoListByPointIdList
                }, null, 8, ["modelValue", "options"])]),
                _: 1
              }), _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  icon: "Search",
                  onClick: handleQuery,
                  class: "satpro-button"
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("搜索", -1)]))]),
                  _: 1
                }), _createVNode(_component_el_button, {
                  icon: "Refresh",
                  onClick: resetQuery,
                  class: "satpro-button"
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("重置", -1)]))]),
                  _: 1
                }), _createVNode(_component_el_button, {
                  icon: "Switch",
                  onClick: updatePicToText,
                  class: "satpro-button"
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("图文切换", -1)]))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 8, ["model"]), [[_vShow, _unref(showSearch)]]), _createVNode(_component_right_toolbar, {
              showSearch: _unref(showSearch),
              "onUpdate:showSearch": _cache[4] || (_cache[4] = $event => _isRef(showSearch) ? showSearch.value = $event : null),
              onQueryTable: getList
            }, null, 8, ["showSearch"])]),
            _: 1
          }), _cache[18] || (_cache[18] = _createElementVNode("div", {
            class: "menu-name"
          }, [_createElementVNode("span", {
            class: "textinfo"
          }, "告警列表")], -1)), !_unref(picToText) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_unref(alarmData).alarmList.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(_unref(alarmData).alarmList, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "listitem",
              key: index
            }, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_image, {
              onClick: $event => handleView(index),
              src: item.recognitionUrl,
              style: {
                "height": "20rem"
              }
            }, null, 8, ["onClick", "src"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_createElementVNode("tr", null, [_cache[12] || (_cache[12] = _createElementVNode("th", null, "告警时间:", -1)), _createElementVNode("td", null, _toDisplayString(item.happenedTime), 1), _cache[13] || (_cache[13] = _createElementVNode("th", null, "任务名称:", -1)), _createElementVNode("td", {
              style: {
                "display": "block",
                "width": "70px",
                "overflow": "hidden",
                "text-overflow": "ellipsis",
                "white-space": "nowrap"
              },
              title: item.taskName
            }, _toDisplayString(item.taskName), 9, _hoisted_10)]), _createElementVNode("tr", null, [_cache[14] || (_cache[14] = _createElementVNode("th", null, "所属部门:", -1)), _createElementVNode("td", {
              style: {
                "display": "block",
                "width": "140px",
                "overflow": "hidden",
                "text-overflow": "ellipsis",
                "white-space": "nowrap"
              },
              title: item.deptName
            }, _toDisplayString(item.deptName), 9, _hoisted_11), _cache[15] || (_cache[15] = _createElementVNode("th", null, "执行设备:", -1)), _createElementVNode("td", null, _toDisplayString(item.deviceName), 1)]), _createElementVNode("tr", null, [_cache[16] || (_cache[16] = _createElementVNode("th", null, "告警事件:", -1)), _createElementVNode("td", null, _toDisplayString(item.reportNames), 1)])])])])]);
          }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[17] || (_cache[17] = [_createElementVNode("span", null, "未查询到告警信息", -1)]))]))])) : _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            key: 1,
            data: _unref(alarmData).alarmList,
            "cell-style": {
              'padding-top': '1.2rem'
            },
            "header-cell-style": {
              background: 'transparent !important',
              color: '#FFFFFF',
              'text-align': 'center'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              key: "taskName",
              align: "center",
              label: "任务名称",
              prop: "taskName"
            }), _createVNode(_component_el_table_column, {
              key: "deptName",
              "show-overflow-tooltip": true,
              align: "center",
              label: "所属部门",
              prop: "deptName"
            }), _createVNode(_component_el_table_column, {
              key: "deviceName",
              "show-overflow-tooltip": true,
              align: "center",
              label: "执行设备",
              prop: "deviceName"
            }), _createVNode(_component_el_table_column, {
              key: "happenedTime",
              "show-overflow-tooltip": true,
              align: "center",
              label: "告警时间",
              prop: "happenedTime"
            }), _createVNode(_component_el_table_column, {
              key: "reportNames",
              "show-overflow-tooltip": true,
              align: "center",
              label: "告警目标",
              prop: "reportNames"
            }), _createVNode(_component_el_table_column, {
              key: "recognitionUrl",
              align: "center",
              label: "告警详情"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_image, {
                src: scope.row.recognitionUrl
              }, null, 8, ["src"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              key: "clearStatus",
              "show-overflow-tooltip": true,
              align: "center",
              label: "处理情况",
              prop: "clearStatus"
            }), _createVNode(_component_el_table_column, {
              align: "center",
              "class-name": "small-padding fixed-width",
              label: "操作"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_tooltip, {
                content: "详情",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  icon: "View",
                  type: "primary",
                  link: "",
                  onClick: $event => handleView(scope.$index)
                }, null, 8, ["onClick"])]),
                _: 2
              }, 1024)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data"])), [[_directive_loading, _unref(loading)]]), _withDirectives(_createVNode(_component_pagination, {
            limit: _unref(data).queryParams.pageSize,
            "onUpdate:limit": _cache[5] || (_cache[5] = $event => _unref(data).queryParams.pageSize = $event),
            page: _unref(data).queryParams.pageNum,
            "onUpdate:page": _cache[6] || (_cache[6] = $event => _unref(data).queryParams.pageNum = $event),
            total: _unref(total),
            pageSizes: _unref(pageSizes),
            onPagination: getList
          }, null, 8, ["limit", "page", "total", "pageSizes"]), [[_vShow, _unref(total) > 0]])]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(_component_el_dialog, {
        title: '告警详情',
        modelValue: _unref(data).detailInfo.show,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(data).detailInfo.show = $event),
        width: "110rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        onBeforeClose: _cache[8] || (_cache[8] = $event => closeDialog()),
        draggable: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          ref_key: "scrollBarImg",
          ref: scrollBarImg,
          class: "scrollBarStyle",
          style: {
            "width": "95%",
            "height": "68rem",
            "top": "0",
            "left": "0",
            "right": "0",
            "bottom": "0",
            "margin": "auto",
            "overflow": "auto"
          },
          onWheel: handleScroll
        }, [_createVNode(_component_el_image, {
          src: _unref(data).detailInfo.alarmDetail.recognitionUrl
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_13, [_createElementVNode("table", _hoisted_14, [_createElementVNode("tr", null, [_createElementVNode("td", _hoisted_15, [_createVNode(_component_el_descriptions, {
          style: {
            "background": "rgb(14, 45, 73)"
          },
          column: 4
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
            label: "告警时间："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(data).detailInfo.alarmDetail.happenedTime), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "告警目标："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(data).detailInfo.alarmDetail.reportNames), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "执行设备："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(data).detailInfo.alarmDetail.deviceName), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, {
            label: "所属部门："
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(data).detailInfo.alarmDetail.deptName), 1)]),
            _: 1
          })]),
          _: 1
        })])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).detailInfo.alarmDetail.recognition, (item, index) => {
          return _openBlock(), _createElementBlock("tr", null, [item.type === 101 ? (_openBlock(), _createElementBlock("td", _hoisted_16, [_createVNode(_component_el_descriptions, {
            column: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "目标："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.reportName) + _toDisplayString(item.label), 1)]),
              _: 2
            }, 1024), item.fireArea ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 0,
              label: "火源面积："
            }, {
              default: _withCtx(() => [_unref(data).detailInfo.alarmDetail.asPosition ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.fireArea) + "㎡", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.fireArea.toFixed(0)) + "像素面积", 1))]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), item.firePerimeter ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 1,
              label: "火线长度："
            }, {
              default: _withCtx(() => [_unref(data).detailInfo.alarmDetail.asPosition ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(item.firePerimeter) + "m", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(item.firePerimeter.toFixed(0)) + "px", 1))]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "目标经纬度："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.lngLat), 1)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)])) : (_openBlock(), _createElementBlock("td", _hoisted_21, [_createVNode(_component_el_descriptions, {
            column: 4
          }, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "目标："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.reportName) + _toDisplayString(item.label), 1)]),
              _: 2
            }, 1024), item.fireArea ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 0,
              label: "火源面积："
            }, {
              default: _withCtx(() => [_unref(data).detailInfo.alarmDetail.asPosition ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.fireArea) + "㎡", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(item.fireArea.toFixed(0)) + "像素面积", 1))]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), item.firePerimeter ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
              key: 1,
              label: "火线长度："
            }, {
              default: _withCtx(() => [_unref(data).detailInfo.alarmDetail.asPosition ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(item.firePerimeter) + "m", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(item.firePerimeter.toFixed(0)) + "px", 1))]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), _createVNode(_component_el_descriptions_item, {
              label: "目标经纬度："
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.lngLat), 1)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024)])), index === 0 && _unref(data).detailInfo.alarmDetail.fireNum > 0 ? (_openBlock(), _createElementBlock("td", {
            key: 2,
            rowspan: _unref(data).detailInfo.alarmDetail.fireNum
          }, [_createVNode(_component_el_descriptions, {
            column: 1
          }, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
              label: "火源总面积："
            }, {
              default: _withCtx(() => [_unref(data).detailInfo.alarmDetail.asPosition ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(data).detailInfo.alarmDetail.fireArea) + "㎡", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_unref(data).detailInfo.alarmDetail.fireArea.toFixed(0)) + "像素面积", 1))]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, {
              label: "火线总长度："
            }, {
              default: _withCtx(() => [_unref(data).detailInfo.alarmDetail.asPosition ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(data).detailInfo.alarmDetail.allFirePerimeter) + "m", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(data).detailInfo.alarmDetail.allFirePerimeter.toFixed(0)) + "px", 1))]),
              _: 1
            })]),
            _: 1
          })], 8, _hoisted_26)) : _createCommentVNode("", true)]);
        }), 256))])])], 544)]),
        _: 1
      }, 8, ["modelValue"])])])]);
    };
  }
};